import type { TrackDef } from '../track';
import { autoGates } from './util';

/**
 * Northfield Airfield: tribute to round 5, Silverstone (design.md A5.5).
 * Fast, flowing, few slow corners: commitment matters more than brakes.
 */
const centerline: [number, number][] = [
  [13, 1.5], [18, 3], [24, 5], [30, 7.5], [36, 8.7], [50, 8.7], [50.5, 5], [52, 3.5],
  [55, 4.5], [58, 6.5], [62, 8.5], [65, 10.5], [66, 13], [66, 22], [64, 24], [59, 27],
  [54, 30.5], [50, 33], [47, 35.5], [44.5, 37.5], [42, 36], [40, 33.5], [37, 31], [33, 29.5],
  [26, 27], [19, 25], [12, 22.5], [8, 20.5], [5.5, 18], [5.5, 15], [7, 12], [8.5, 8],
  [10.5, 5], [11, 3],
];

export const NORTHFIELD: TrackDef = {
  id: 'northfield',
  name: 'NORTHFIELD AIRFIELD',
  subtitle: 'Tribute to Silverstone',
  country: 'BRITAIN',
  theme: 'park',
  scale: 45.3,
  offset: [5, 5],
  centerline,
  roadWidth: 78,
  kerbWidth: 6,
  runoffWidth: 26,
  runoffSurface: 'grass',
  gates: autoGates(centerline, 5, 0.5, 6),
  carparks: [],
  raceLaps: 3,
  defaultRecord: 25.5,
};
